import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-free-trial-form',
  templateUrl: './free-trial-form.component.html',
  styleUrls: ['./free-trial-form.component.scss']
})
export class FreeTrialFormComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
